export default "__VITE_ASSET__DMkdzpVl__"